<template>
  <Modal v-model="importFreightTemplateModal" :title="$t('key1000547')" :transfer="false" width="600"
    :mask-closable="false" @on-visible-change="importFreightTemplateChange">
    <Form ref="importForm" :model="importForm" @submit.native.prevent>
      <FormItem :label="$t('key1000548')" prop="priceType" class="radio_styles">
        <RadioGroup v-model="importForm.priceType">
          <Radio v-for="(item,index) in billingList" class="mr20" :key="index" :label="item.value">{{ item.label }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('key1000549')" prop="weightType" class="radio_styles">
        <RadioGroup v-model="importForm.weightType">
          <Radio v-for="(item,index) in weightTypeList" class="mr20" :key="index" :label="item.value">{{ item.label }}</Radio>
        </RadioGroup>
        <span v-if="importForm.weightType !== 1">
          <span>{{ $t('key1000552') }}</span>
          <Input style="width: 100px;" v-model="importForm.volumeWeight"/>)
        </span>
      </FormItem>
      <FormItem :label="$t('key1000550')" class="styles_item">
        <div class="fl">
          <Upload
            style="display: inline-block"
            :headers="headObj"
            ref="uploadRef"
            name='excleFile'
            :data="importForm"
            :show-upload-list="false"
            :action="uploadZoneExcel"
            :before-upload="beforeHandleUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-format-error="handleFormatError"
            :max-size="uploadFilesMaxSize"
            :format="['xls', 'xlsx']">
            <Button class="mr10">{{ $t('key1000553') }}</Button>
          </Upload>
          <div v-if="file !== null"> {{ file.name }}</div>
        </div>
        <a class="ml20" @click="download">{{ $t('key1000554') }}</a>
      </FormItem>
      <FormItem :label="$t('key1000551')" prop="covered" class="radio_styles">
        <RadioGroup v-model="importForm.covered">
          <Radio v-for="(item,index) in importTypeList" class="mr20" :key="index" :label="item.value">{{ item.label }}</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <template #footer>
      <Button type="primary" :loading="loadingTalg" @click="saveImport">{{ $t('key1000555') }}</Button>
      <Button @click="importFreightTemplateModal=false">{{ $t('key1000112') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import {getDataSetBatchList, getEnumList, getImportTemplate} from "@/utils/common";

export default {
  name: "importFreightTemplateModal",
  mixins: [Mixin],
  props: {
    sourceType: {
      type: String,
      default: 'basicLogistics' // basicLogistics 基本物流、ymsLogistics YMS物流、selfOwnedLogistics 供应商系统--物流管理--自有物流
    },
    uploadZoneExcel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      importFreightTemplateModal: false,
      importForm: {
        priceType: 1,
        covered: 1,
        volumeWeight: '', // 材积重
        shippingMethodId: '',
        weightType: 1
      },
      importTypeList: [ // 导入处理
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000544'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000545'), value: 2}
      ],
      file: null,
      loadingTalg: false,
      enumData: [],
    };
  },
  computed: {
    // 计重方式
    weightTypeList() {
      const ENUM_KEY = 'YmsLogisServicePriceModelZoneWeightTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
    // 计费方式
    billingList() {
      const ENUM_KEY = 'YmsLogisServicePriceModelZonePriceTypeCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    },
  },
  methods: {
    // 初始化数据
    async initImportFreightTemplateData(shippingMethodId, arriveableType) {
      let enumKeyList = ['YmsLogisServicePriceModelZoneWeightTypeCoreEnum', 'YmsLogisServicePriceModelZonePriceTypeCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      this.importForm.shippingMethodId = shippingMethodId;
      this.arriveableType = arriveableType;
      this.importFreightTemplateModal = true;
    },
    // 导入运费模板弹窗--批量上传文件
    beforeHandleUpload(file) {
      this.file = file;
      return false;
    },
    // 导入运费模板弹窗--批量上传文件失败
    uploadError() {
      this.loadingTalg = false;
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000195'));
    },
    // 导入运费模板弹窗--下载文件模板
    download() {
      let v = this;
      let type = {
        'basicLogistics': "carrierShippingMethodPriceModelZone",
        'ymsLogistics': "ymsLogisServicePriceModelZone",
        'selfOwnedLogistics': "supplierShippingMethodPriceModelZone",
      };
      getImportTemplate(
        type[this.sourceType],
        {
          priceType: v.importForm.priceType,
          globalAccessible: v.arriveableType === 1
        }
      )
    },
    // 导入运费模板弹窗--保存按钮
    saveImport() {
      let v = this;
      v.loadingTalg = true;
      if (v.file) {
        v.$refs['uploadRef'].post(this.file); // 手动上传
        setTimeout(() => {
          v.file = null;
          v.loadingTalg = false;
        }, 2000);
      } else {
        v.loadingTalg = false;
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000546'));
        return false;
      }
    },
    // 导入运费模板弹窗--批量上传文件成功
    uploadSuccess(res, file, fileList) {
      this.$emit('updateImportFreightTemplateData', {
        data: res,
        coveredType: this.importForm.covered
      });
    },
    // 监听弹窗
    importFreightTemplateChange(value) {
      if (!value) {
        this.file = null;
        this.$refs['importForm'].resetFields();
        this.importForm.volumeWeight = '';
      }
    }
  }
};
</script>

<style scoped>

</style>
